import Link from "next/link"
import React from "react"
import { withI18n } from "~/hocs"
import { buildName} from '~/utils'
import {
  Breadcrumb,
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Modal,
} from "react-bootstrap"
import { routes } from "~/router"
import { QRCodeCanvas } from 'qrcode.react'

const BitcoinAddress = ({ t, video, showBitcoin,setShowBitcoin,handleCloseBitcoin,lng }) => {
  return (
    <Modal show={showBitcoin} onHide={handleCloseBitcoin}>
      <Modal.Header closeButton className="d-block modal-header-bitcoin">
        <Modal.Title>
          <div className="text-center">
            <img src="/bitcoin_icon_video.svg" alt="" width="40" />
            {buildName(video.user, lng)}さんのビットコインアドレス
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {video.user?.bitcoin_address ? (
          <>
            <div className="bitcoin-address-text ac-p-1 bg-e6e6e6 text-center ac-mb-2">
              {video.user.bitcoin_address}
            </div>
            <div className="mb-2 text-center">
              <QRCodeCanvas value={video.user.bitcoin_address} />
            </div>
            <p className="font-weight-bold text-center">
              ご利用のビットコインアプリからQRコードを読み込むか、
            </p>
            <p className="font-weight-bold text-center">
              ビットコインアドレスをコピーしてご利用ください 。
            </p>
          </>
        ) : (
          <p className="text-center">
            この作成者はビットコインアドレスを持っていません
          </p>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default withI18n(BitcoinAddress)
